import { useEffect, useState } from 'react';
import React from 'react';
import { Link } from 'react-router-dom';
import { LazyLoadComponent } from 'react-lazy-load-image-component'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import { Swiper, SwiperSlide } from "swiper/react"
import { Autoplay } from "swiper"
import 'swiper/css';
import { useTranslation } from 'react-i18next';

import { useShoppingCart } from '../../context/ShoppingCartContext';
import { useGeral } from '../../context/GeralContext';

import './Home.css';
import logo from '../../assets/img-skeleton.png';
import NewArrivals from '../../components/NewArrivals/NewArrivals';

const HomeID = React.lazy(() => import('./HomeContainer/HomeContainer-' + process.env.REACT_APP_ID_BRAND))

function Home(props) {
    const { t } = useTranslation()
    const { errorToast, openLogin } = useShoppingCart()
    const { tokenUser } = useGeral()
    const [listings, setListings] = useState<any[]>([])
    const [currency, setCurrency] = useState()

    const [banner, setBanner] = useState<any>([])
    const [bannerMob, setBannerMob] = useState<any>([])

    const [loadingNewArrivals, setLoadingNewArrivals] = useState<boolean>(true)
    const [newArrivalsArr, setNewArrivalsArr] = useState<any>(null)

    useEffect(() => {
        getListings()
        getNewArrivals()
        localStorage.removeItem('productToResell')
        localStorage.removeItem('searchParam')
    }, []);

    useEffect(() => {
        setBanner(props?.brandDetails.photo_links)
    }, [props?.brandDetails.photo_links]);

    const getListings = async () => {
        var myHeaders = new Headers();
        if (tokenUser) {
            myHeaders.append("Authorization", "Bearer " + tokenUser);
        }

        var requestOptions: RequestInit = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        fetch(process.env.REACT_APP_URL + '/products/listings/all?limit=0&rule=recent_first&' +
            'id_brand=' + process.env.REACT_APP_ID_BRAND,
            requestOptions)
            .then(async response => {
                if (response.ok) {
                    return response.json();
                } else {
                    var error = await response.text();
                    return Promise.reject({ status: response.status, message: error });
                }
            })
            .then(result => {
                setCurrency(result.currency_symb_code)
                setListings(result.products_listings)
                setLoadingNewArrivals(false)
            })
            .catch(error => {
                errorToast(error)
            });
    }
    function getNewArrivals() {
        var myHeaders = new Headers();
        if (tokenUser) {
            myHeaders.append("Authorization", "Bearer " + tokenUser);
        }

        var requestOptions: RequestInit = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        fetch(process.env.REACT_APP_URL + '/products/newarrivals?id_brand=' + process.env.REACT_APP_ID_BRAND, requestOptions)
            .then(async response => {
                if (response.ok) {
                    return response.json();
                } else {
                    var error = await response.text();
                    return Promise.reject({ status: response.status, message: error });
                }
            })
            .then(result => {
                setNewArrivalsArr(result)
                setLoadingNewArrivals(false)
            })
            .catch(error => {
                errorToast(error)
            });
    }

    return (
        <>
            <div className='relative'>
                <div className='home_banner min-h-[500px] flex'>
                    <Swiper className="w-full h-full"
                        slidesPerView={1}
                        loop={true}
                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                        }}
                        modules={[Autoplay]}
                    >
                        {/* window.screen.width >= 768 &&  */}
                        {banner?.map((image, index) => (
                            <SwiperSlide key={index} className='w-full !h-auto'>
                                <div className="w-full h-full bg-cover bg-no-repeat bg-center" style={{ backgroundImage: 'url(' + image + ')' }}></div>
                            </SwiperSlide>
                        ))}
                        {/* {window.screen.width < 768 && bannerMob.map((image, index) => (
                            <SwiperSlide key={index} className='w-full !h-auto'>
                                <div className="w-full h-full bg-cover bg-no-repeat bg-center" style={{ backgroundImage: 'url(' + image + ')' }}></div>
                            </SwiperSlide>
                        ))}
                        <SwiperSlide>
                            <div className="hidden md:flex w-full h-full bg-cover bg-no-repeat bg-center" style={{ backgroundImage: 'url(' + banner + ')' }}></div>
                            <div className="flex md:hidden w-full h-full bg-cover bg-no-repeat bg-center" style={{ backgroundImage: 'url(' + bannerMob + ')' }}></div>
                        </SwiperSlide>*/}
                    </Swiper >
                </div>
                <div className='home_banner_container z-30 w-auto absolute uppercase flex flex-col top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4'>
                    <img src={process.env.REACT_APP_2HDICON_WHITE ? process.env.REACT_APP_2HDICON_WHITE : process.env.REACT_APP_2HDICON} width={'500px'} height={'100px'}
                        className='py-6 image'></img>
                    <div className='text flex flex-col justify-center items-center'>
                        <div className='text-title text-center font-medium text-3xl py-6'>{process.env.REACT_APP_TITLE}</div>
                        <div className='text-description text-center'>{process.env.REACT_APP_DESCRIPTION}</div>
                    </div>
                    <div className='home_banner_buttons uppercase flex flex-row justify-center mt-8 gap-6'>
                        <Link to={"/all"} className="extra-button-small uppercase font-medium">{t('home.shop')}</Link>
                        {tokenUser ? <Link to="/user/submit-item-2hand" className="extra-button uppercase font-medium">{t('home.sell')}</Link> :
                            <button onClick={openLogin} className="extra-button-small uppercase font-medium">{t('home.sell')}</button>}
                    </div>
                </div>
            </div>
            <div className="home-page bg-white">
                <div id="home-container" className="page-container flex flex-col mx-auto !py-0 px-4 sm:px-6 lg:px-8">
                    <div className='home-page-circular h-min flex flex-col justify-end items-center'>
                        <div className='title py-6 uppercase font-medium text-xl text-center'>{process.env.REACT_APP_2HD_TITLE_HOME}</div>
                        <div className='text mb-6 flex flex-col justify-end items-center'>
                            <div className='hidden md:flex mt-4 md:uppercase text-center lg:w-11/12 whitespace-pre-line'>{process.env.REACT_APP_2HD_TEXT_HOME}</div>
                            <div className='flex md:hidden mt-4 text-center whitespace-pre-line'>{process.env.REACT_APP_2HD_TEXT_SMALL_HOME}</div>
                            <div className='circular-buttons flex flex-wrap gap-3 mt-4 justify-center items-center'>
                                <Link to={"/about"} className='discover_more primary-button uppercase font-medium w-auto'>{t('home.discover_more')}</Link>
                                <Link to={"/shop-pre-loved"} className='shop_2nd_hand primary-button uppercase font-medium w-auto'>{t('home.shop_second_hand')}</Link>
                                <Link to={"/shop-beautiful-losers"} className='shop_blosers primary-button uppercase font-medium w-auto'>{t('home.shop_blosers')}</Link>
                                <Link to={"/sell"} className='sell primary-button uppercase font-medium w-auto'>{t('home.sell')}</Link>
                            </div>
                        </div>
                    </div>
                    <h1 className="sr-only">{process.env.REACT_APP_TITLE}</h1>
                    <div className='home-page-products w-full flex flex-col relative'>
                        {/* <h2 className="text-xl font-medium">Recent items</h2> */}
                        {listings.length === 0 && <div className='w-full flex justify-center items-center'><div className="loading bg-contain bg-no-repeat" style={{ backgroundImage: "url(" + props.brandDetails?.mini_logo + ")" }}></div></div>}
                        <div className="products-list grid gap-y-10 gap-x-3 grid-cols-2 md:grid-cols-4 xl:grid-cols-6">
                            {listings.map((product, index) => (
                                <Link key={index} className="flex flex-col justify-between no-underline" to={'/product/' + product.product_id + '?variant=' + product.product_variant_id}>
                                    <div className="group relative h-full w-full flex">
                                        <LazyLoadImage
                                            src={product.photo}
                                            alt={product.title}
                                            width='100%'
                                            height='100%'
                                            loading="lazy"
                                            placeholderSrc={logo}
                                            className="absolute inset-0 h-full w-full object-contain object-bottom group-hover:opacity-75"
                                        />
                                        {product?.Size?.length > 0 && <div className="block-sizes absolute p-4 bottom-0 w-full hidden sm:group-hover:flex">
                                            <object className='w-full'><div className="bg-white p-3 w-full">
                                                <p className="mt-1 mb-2 text-sm font-small text-center">{t('shopping.sizes')}</p>
                                                <div className='flex flex-wrap justify-center'>
                                                    {product.Size?.map((size, index) => (
                                                        <Link key={index} className='mx-2 my-1 no-underline text-sm hover:font-bold' to={'/product/' + product.product_id + '?variant=' + size.product_variant_id}>
                                                            <p>{size.O2Child}</p>
                                                        </Link>
                                                    ))}
                                                </div>
                                            </div></object>
                                        </div>}
                                    </div>
                                    <div className='list-product-details mt-4 flex flex-col'>
                                        <div className='flex justify-between gap-3 overflow-hidden'>
                                            <div className="subtitle2 text-sm truncate">{product.title}</div>
                                            {/* <button className={(product.wishlisted ? 'heart' : '')}><HeartIcon className={'h-5 w-5 flex-shrink-0 hover:fill-black ' + (product.wishlisted ? "fill-red-500 stroke-red-500 hover:fill-red-500" : "stroke-black")} title={product.wishlisted ? "Remove from wishlist" : "Add to wishlist"} onClick={(e) => addToWishlist(e, product)}></HeartIcon></button> */}
                                        </div>
                                        <div className="colors flex mt-1 text-sm">{product?.option1array?.length} {product?.option1array?.length > 1 ? <span>&nbsp;{t('shopping.colors_available')}</span> : <span>&nbsp;{t('shopping.color_available')}</span>}</div>
                                        <div className="price mt-1 text-lg font-medium">
                                            <div className="flex">{product.min_price}{currency}{product.min_price !== product.max_price && product.max_price && <div>-{product.max_price}{currency}</div>}</div>
                                        </div>
                                    </div>
                                </Link>
                            ))}
                        </div>
                        {listings.length > 0 && <div className='button-viewall flex justify-center items-center w-auto'>
                            <Link to={"/all"} className='primary-button font-medium uppercase my-4'>{t('home.view_all')}</Link>
                        </div>}
                    </div>
                    <HomeID></HomeID>
                </div>
                {!loadingNewArrivals && <div className="new-arrivals-block !mx-auto px-6 md:px-0 md:py-16 pb-0">
                    <h2 className="mb-4 subtitle font-medium">LATEST ADDITIONS</h2>
                    <div className="new-arrivals mt-6">
                        <LazyLoadComponent>
                            <NewArrivals arr={newArrivalsArr}></NewArrivals>
                        </LazyLoadComponent>
                    </div>
                </div>}
            </div>
        </>
    )
}

export default Home;